"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRtbProps = exports.RtbBlock = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lightbulb = _interopRequireDefault(require("@ux/icon/lightbulb"));
var _classnames = _interopRequireDefault(require("classnames"));
var _uuid = require("uuid");
const getRtbProps = customRtbs => {
  const defaultRtbProps = {
    notYetImplementedDoNotUse: ''
  };
  return customRtbs || defaultRtbProps;
};
exports.getRtbProps = getRtbProps;
const RtbBlock = ({
  rtbs = [],
  dataCy = 'rtb_block',
  headlinerText,
  defaultRtbIcon = /*#__PURE__*/_react.default.createElement(_lightbulb.default, {
    "alt-text": "light bulb",
    "data-testid": "light-bulb",
    role: "presentation",
    className: "font-primary-bold"
  }),
  customSeparator,
  classNames = {}
}) => {
  const {
    rtbBlock,
    headliner,
    rtb,
    rtbList
  } = classNames;
  if (rtbs.length === 0) {
    // Must have at least 1 RTB.
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": dataCy,
    "data-testid": "rtb-block",
    className: rtbBlock || 'd-flex-row'
  }, customSeparator || /*#__PURE__*/_react.default.createElement("hr", {
    className: "w-100"
  }), /*#__PURE__*/_react.default.createElement("div", null, headlinerText && /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": `${dataCy}_headlinerText`,
    "data-testid": "rtb-headliner-text",
    className: headliner || 'font-weight-bold ms1'
  }, headlinerText), /*#__PURE__*/_react.default.createElement("div", {
    id: `${dataCy}_rtb_list`,
    "data-testid": "rtb-list",
    className: rtbList || 'mt-1'
  }, rtbs.map(({
    text,
    icon,
    tooltip
  }, index) => {
    const rtbClassName = rtb || (0, _classnames.default)('d-flex align-items-center', {
      'mt-2': index !== 0 && headlinerText,
      'mt-3': index !== 0 && !headlinerText
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      key: `${_uuid.v4}_${text}`,
      "data-testid": "rtb",
      className: rtbClassName
    }, icon || defaultRtbIcon, text, tooltip);
  }))));
};
exports.RtbBlock = RtbBlock;
RtbBlock.propTypes = {
  rtbs: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    icon: _propTypes.default.element,
    tooltip: _propTypes.default.element
  })),
  dataCy: _propTypes.default.string,
  headlinerText: _propTypes.default.string,
  defaultRtbIcon: _propTypes.default.element,
  customSeparator: _propTypes.default.element,
  classNames: _propTypes.default.shape({
    rtbBlock: _propTypes.default.string,
    headliner: _propTypes.default.string,
    rtb: _propTypes.default.string,
    rtbList: _propTypes.default.string
  })
};